var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      staticClass: "tm-shelf",
      class: { "tm-shelf--visible": _vm.isVisible },
      attrs: { id: "tm-shelf" }
    },
    [
      _c("div", { staticClass: "tm-shelf__drawer" }, [
        _c(
          "div",
          { staticClass: "tm-shelf__drawer__header" },
          [
            _c(
              "router-link",
              { staticClass: "tm-shelf__drawer__logo", attrs: { to: "/" } },
              [
                _c("img", {
                  staticClass: "tm-shelf__drawer__img",
                  attrs: {
                    src: require("@/assets/logo-white.svg"),
                    alt: "tamsin.io"
                  }
                })
              ]
            ),
            _c(
              "button",
              {
                staticClass: "tm-shelf__close material-icons-round",
                attrs: {
                  "aria-controls": "tm-shelf",
                  "aria-expanded": _vm.isVisible
                },
                on: { click: _vm.close }
              },
              [_vm._v("close")]
            )
          ],
          1
        ),
        _c("div", { staticClass: "tm-shelf__drawer__body" }, [
          _c(
            "ul",
            { staticClass: "tm-shelf__drawer__links" },
            _vm._l(_vm.links, function(link) {
              return _c(
                "li",
                { key: link.label },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "tm-shelf__drawer__link",
                      attrs: { to: link.link },
                      nativeOn: {
                        click: function($event) {
                          return _vm.close($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(link.label))]
                  )
                ],
                1
              )
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }